import axios from 'axios';
import { useQuery } from '@tanstack/react-query';
import { BrokerRequestsResponse } from '@/types';
import { GET_BROKER_MESSAGE } from '@/constants';

export const useGetBrokerRequests = (objectId?: string, enabled?: boolean) =>
  useQuery({
    queryKey: ['broker-messages', String(objectId)],
    queryFn: () =>
      axios.get<BrokerRequestsResponse>(`${GET_BROKER_MESSAGE}/${objectId}`).then((res) => {
        return res.data;
      }),
    refetchOnWindowFocus: false,
    staleTime: 0,
    enabled: Boolean(objectId) && (enabled ?? true),
  });
